import { render, staticRenderFns } from "./modalFormulas.vue?vue&type=template&id=2f2e9a17"
import script from "./modalFormulas.vue?vue&type=script&lang=js"
export * from "./modalFormulas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports